// ABOUTME: Reusable search input component with SearchIcon and conditional ClearIcon.
// Pair with useSearch hook for state management and debounced API dispatch.
import React from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { CustomTextField } from './CustomTextFields';

const SearchBar = ({
    value,
    onChange,
    onClear,
    inputRef,
    placeholder = 'Search…',
    sx,
    startAdornment,
}) => (
    <CustomTextField
        size="small"
        value={value}
        onChange={onChange}
        inputRef={inputRef}
        placeholder={placeholder}
        InputProps={{
            startAdornment: (
                <InputAdornment position="start">
                    {startAdornment ?? <SearchIcon color="action" />}
                </InputAdornment>
            ),
            endAdornment:
                value && onClear ? (
                    <InputAdornment position="end">
                        <IconButton size="small" onClick={onClear} edge="end">
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    </InputAdornment>
                ) : null,
        }}
        sx={{ maxWidth: 500, ...sx }}
    />
);

export default SearchBar;
